const en = {
  'Кейсы': 'Cases',
  'Создать бесплатно': 'Create for free',
};

const ru = {};

const translations = { en, ru };
export default translations;
